import { ShowTaskTable, TaskProvider } from 'modules/task';

interface ObjectCardTasksProps {
    objectId: number;
}

const ObjectCardTasks = ({ objectId }: ObjectCardTasksProps) => {
    const id = Number(objectId || 0);
    if (!id) return null;

    return (
        <div className="off-object-4team-tasks">
            <TaskProvider objectId={id}>
                <ShowTaskTable objectId={id} />
            </TaskProvider>
        </div>
    );
};

export default ObjectCardTasks;
